/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../IEnergyManagementProps';
import EnergyManagementSiteDashboardContent from './EnergyManagementSiteDashboardContent';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { PollingContextProvider } from '../../../context/PollingContext/PollingContext';
import { FilterScope1Provider } from '../../../context/FilterScope1Context/FilterScope1Context';
import { withLocalization } from '../../../locales/withLocalization';

const EnergyManagementSiteDashboard = (props: IEnergyManagementProps) => {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    displayWidgets
  } = props;

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <PollingContextProvider>
          <FilterScope1Provider>
            <div className="energy-management-dashboard emaas-siteview-dashboard">
              <EnergyManagementSiteDashboardContent
                bearerToken={bearerToken}
                requestContext={requestContext}
                connectorConfig={connectorConfig}
                emaasContext={emaasContext}
                displayWidgets={displayWidgets}
              />
            </div>
          </FilterScope1Provider>
        </PollingContextProvider>
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  EnergyManagementSiteDashboard
);
